import { useCallback } from 'react';

import { scrollIntoView } from 'shared/utils/dom';

import type { RefObject } from 'react';

export const useScrollIntoView = <Ref extends RefObject<HTMLElement>>(
  ref: Ref,
) => useCallback(() => scrollIntoView(ref?.current), [ref]);
